// get_masterclass_certificate
export const GET_MASTERCLASS_CERTIFICATE = 'get_masterclass_certificate';
export const GET_MASTERCLASS_CERTIFICATE_SUCCESSFUL =
  'get_masterclass_certificate_successfull';
export const GET_MASTERCLASS_CERTIFICATE_FAILED =
  'get_masterclass_certificate_failed';

// create_masterclass_certificate
export const CREATE_MASTERCLASS_CERTIFICATE = 'create_masterclass_certificate';
export const CREATE_MASTERCLASS_CERTIFICATE_SUCCESSFUL =
  'create_masterclass_certificate_successfull';
export const CREATE_MASTERCLASS_CERTIFICATE_FAILED =
  'create_masterclass_certificate_failed';

// update_masterclass_certificate
export const UPDATE_MASTERCLASS_CERTIFICATE = 'update_masterclass_certificate';
export const UPDATE_MASTERCLASS_CERTIFICATE_SUCCESSFUL =
  'update_masterclass_certificate_successfull';
export const UPDATE_MASTERCLASS_CERTIFICATE_FAILED =
  'update_masterclass_certificate_failed';

// delete_masterclass_certificate
export const DELETE_MASTERCLASS_CERTIFICATE = 'delete_masterclass_certificate';
export const DELETE_MASTERCLASS_CERTIFICATE_SUCCESSFUL =
  'delete_masterclass_certificate_successfull';
export const DELETE_MASTERCLASS_CERTIFICATE_FAILED =
  'delete_masterclass_certificate_failed';
